export default __webpack_public_path__ + "static/media/DangerIcon.3525c20b.svg";